import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { RowClassArgs } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-pos-tfg-campaign-details',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './pos-tfg-campaign-details.component.html',
  styleUrls: ['./pos-tfg-campaign-details.component.scss'],
})
export class PosTfgCampaignDetailsComponent implements OnInit {
  @Input() tfgCampaignDetails: any[];
  @Input() showCampaignTotals: boolean = false;

  constructor() {}

  ngOnInit(): void {}

  // Use an arrow function to capture the 'this' execution context of the class.
  public rowCallback = (context: RowClassArgs) => {
    if (context.dataItem.itemType === 'EXCLUDE') {
      return { exclude: true };
    }

    if (context.dataItem.itemType === 'PURCHASE') {
      return { purchase: true };
    }

    if (context.dataItem.itemType === 'REDEEM') {
      return { redeem: true };
    }

    return null;
  };
}
